import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment } from "react";
import { HeaderGroup, Row } from "react-table";

import { CaseAdmin } from "pwapi";

import ReactTableRow from "../table/ReactTableRow";
import Table from "../table/Table";

type OrdersTableViewProps = {
  headerGroups: HeaderGroup<any>[];
  rows: Row<any>[];
  prepareRow: Function;
  adminCase?: CaseAdmin;
};

const OrdersTableView = ({
  headerGroups,
  rows,
  prepareRow,
}: OrdersTableViewProps) => {
  return (
    <Table
      className="PWTable--orders"
      headerGroups={headerGroups.map((headerGroup, index) => (
        <tr
          {...headerGroup.getHeaderGroupProps()}
          key={index}
          className="orders__headers"
        >
          {headerGroup.headers.map((column: any) => (
            <th
              {...column.getHeaderProps(column.getSortByToggleProps())}
              key={`column:${column.id}`}
            >
              {column.render("Header")}
              <span>
                {column.isSorted ? (
                  column.isSortedDesc ? (
                    <FontAwesomeIcon icon="angle-down" />
                  ) : (
                    <FontAwesomeIcon icon="angle-up" />
                  )
                ) : (
                  ""
                )}
              </span>
            </th>
          ))}
        </tr>
      ))}
      rows={rows.map((row) => {
        prepareRow(row);
        return (
          <Fragment
            {...row.getToggleRowExpandedProps}
            key={`case:${row.original.id}`}
          >
            <ReactTableRow row={row} />
          </Fragment>
        );
      })}
    />
  );
};

export default OrdersTableView;
